module.exports = __webpack_public_path__ + "img/Nei Mongol-speed.2c327234.png";